module.exports = __webpack_public_path__ + "img/googleDrive.f6ee6d6b.svg";